/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { map } from 'lodash';
import { passwordCreationUtils } from '@blend/shared-react';
export const getPasswordRequirements = (password, confirmedPassword) => {
  const stengthRequirements = passwordCreationUtils.getValidityStatus(password);
  const requirements = [...map(stengthRequirements, req => ({
    ...req,
    description: `Password requires ${req.description}`
  })), {
    description: 'Passwords must match',
    isMet: password === confirmedPassword
  }];
  return requirements;
};